// extracted by mini-css-extract-plugin
export default {"checkbox":"AppCheckbox_checkbox__YBHOc","checkboxDisabled":"AppCheckbox_checkboxDisabled__qvte3","checkboxIcon":"AppCheckbox_checkboxIcon__MAEmt"};